// @flow
import DecimalFormat from "../../../utils/number/DecimalFormat";

import type { IConstraintModel } from "../../types";

const DEFAULT_GROUPING_SIZE = 3;

/**
 */
class NumberGroupingConstraint implements IConstraintModel {
  _decimalSeparator: string;
  _groupingSeparator: string;
  _format: string;

  /**
   */
  constructor(
    groupingSeparator: string = ",",
    decimalSeparator: string = ".",
    format: ?string = "0",
  ) {
    this._decimalSeparator = decimalSeparator;
    this._groupingSeparator = groupingSeparator;
    this._format = format ?? "0";
  }

  /**
   */
  get id(): string {
    return "Constraint.Number.GroupingSeparator";
  }

  /**
   */
  get decimalSeparator(): string {
    return this._decimalSeparator;
  }

  /**
   */
  get groupingSeparator(): string {
    return this._groupingSeparator;
  }

  /**
   */
  get format(): string {
    return this._format;
  }

  /**
   */
  get groupSize(): number {
    if (this.format) {
      const fromFormat = new DecimalFormat(this.format).comma;
      if (fromFormat > 0) {
        return fromFormat;
      }
    }

    return DEFAULT_GROUPING_SIZE;
  }

  /**
   */
  hasValidation(): boolean {
    return true;
  }

  /**
   */
  get defaultMessage(): string {
    return "Group divider '${group-divider}' must be correctly placed"; // NOSONAR
  }

  /**
   */
  get parameters(): { "group-divider": string } {
    return { "group-divider": this.groupingSeparator };
  }

  /**
   */
  // $FlowFixMe
  hasCorrectGrouping(value: string) {
    // A negative or a negative value may cause an incorrect group length compared to groupSize. To avoid this, the negative or positive sign must be removed from the value.
    const absStringValue = value.replace("-", "").replace("+", "");

    if (!absStringValue.includes(this.groupingSeparator)) {
      return true;
    }

    let integer = absStringValue;
    if (
      this.decimalSeparator !== "" &&
      absStringValue.includes(this.decimalSeparator)
    ) {
      // decimal before grouping
      if (
        absStringValue.indexOf(this.decimalSeparator) <
        absStringValue.indexOf(this.groupingSeparator)
      ) {
        return false;
      }

      integer = absStringValue.substring(
        0,
        absStringValue.indexOf(this.decimalSeparator),
      );
    }

    let groups = integer.split(this.groupingSeparator);

    // when the first item is smaller than group size, remove it from check
    if (groups[0].length < this.groupSize) {
      groups = groups.slice(1);
    }

    return groups.every((group) => group.length === this.groupSize);
  }

  /**
   */
  validate(value: string | number): boolean {
    return (
      this.groupingSeparator === "" ||
      typeof value !== "string" ||
      !value.includes(this.groupingSeparator) ||
      this.hasCorrectGrouping(value)
    );
  }

  /**
   */
  get isMandatoryConstraint(): boolean {
    return false;
  }
}

export default NumberGroupingConstraint;
